export enum LayersCopiedStatus {
    Completed = "Completed",
    Processsing = "Processsing",
    Failed = "Failed",
    ValidationError = "ValidationError"
}